import { CSSProperties } from "react";
import { PrimaryButton, Stack, getTheme } from "@fluentui/react";

import Illustration from "./assets/illustration.svg";
import { useNavigateWithParams } from "utils/components/LinkWithParams";

export const LandingBanner = () => {
  const navigate = useNavigateWithParams();

  const handleButtonClick = () => {
    navigate("/collections/#create", { state: { panelOpen: true, mode: "create" } });
  };

  return (
    <div style={containerStyle}>
      <Stack horizontal horizontalAlign="space-between">
        <div style={{ margin: 36, marginBottom: 40 }}>
          <span
            aria-label="Planetary Computer Pro"
            style={titleStyle}
            role="heading"
            aria-level={1}
          >
            Planetary Computer Pro
          </span>
          <p style={blurbStyle}>
            Unify geospatial data with enterprise AI and analytics to enhance
            business decisions.
          </p>
          <PrimaryButton text="Create collection" onClick={handleButtonClick} />
        </div>
      </Stack>
    </div>
  );
};

const theme = getTheme();

const containerStyle: CSSProperties = {
  backgroundColor: "#F4F3F5",
  backgroundImage: `url(${Illustration})`,
  backgroundPosition: "right",
  backgroundRepeat: "no-repeat",
  color: theme.palette.black,
};

const blurbStyle: CSSProperties = {
  maxWidth: 600,
  fontFamily: "Segoe UI",
  fontSize: 17,
  marginBottom: 40,
};

const titleStyle: CSSProperties = {
  fontSize: 39,
  fontWeight: "400",
  fontFamily: "Segoe UI",
};
